<div class="card-header">
  <h2>Quick links</h2>
</div>

<div class="link-row">
  <div class="link-icon green">
    <mat-icon>menu_book</mat-icon>
  </div>
  <div class="link-content">
    <h4>Getting started with Kanga</h4>
    <p>
      New to Kanga? Check out this valuable collection of Help Center Articles
    </p>
    <ul>
      <li>
        <a
          href="https://support.presence.com/hc/en-us/sections/27025937195027-Getting-Started-with-Kanga"
          target="_blank"
          rel="noopener noreferrer"
        >
          Getting Started With Kanga
        </a>
      </li>
    </ul>
  </div>
</div>

<div class="link-row" *ngIf="(hideExternalTools$ | async) !== true">
  <div class="link-icon blue">
    <mat-icon>link</mat-icon>
  </div>
  <div class="link-content">
    <h4>External tools</h4>
    <p>Commonly accessed sites and tools, here for your convenience</p>
    <ul>
      <li>
        <a
          href="https://qglobal.pearsonassessments.com/qg/login.seam"
          target="_blank"
          rel="noopener noreferrer"
        >
          Q-Global
        </a>
      </li>
      <li>
        <a
          href="https://www.wjscore.com/WJIV/Home/Index/2"
          target="_blank"
          rel="noopener noreferrer"
        >
          WJ Score
        </a>
      </li>
      <li>
        <a
          href="https://hub.wpspublish.com/landing"
          target="_blank"
          rel="noopener noreferrer"
        >
          Western Psychological Services
        </a>
      </li>
    </ul>
  </div>
</div>
